export const jsonPrettify = (uglyJson) => {
  try {
    return JSON.stringify(uglyJson, undefined, 4)
  } catch (e) {
    return uglyJson
  }
}
